<template>
  <nav class="navbar">
    <div class="nav-container">
      <div class="nav-logo">
        <img src="/logo.png" alt="Pulse Creative Solutions" class="logo-img">
        <h2 class="logo-text">Pulse Creative Solutions</h2>
      </div>
      
      <div class="nav-menu" :class="{ 'active': isMenuOpen }">
        <router-link to="/" class="nav-link" @click="closeMenu">Home</router-link>
        <router-link to="/services" class="nav-link" @click="closeMenu">Services</router-link>
        <router-link to="/careers" class="nav-link" @click="closeMenu">Careers</router-link>
        <router-link to="/about" class="nav-link" @click="closeMenu">About us</router-link>
        <router-link to="/contact" class="nav-link" @click="closeMenu">Contact us</router-link>
      </div>
      
      <div class="hamburger" @click="toggleMenu">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navigation',
  data() {
    return {
      isMenuOpen: false
    }
  },
  watch: {
    // 监听路由变化
    $route() {
      this.isMenuOpen = false;
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    }
  }
}
</script>

<style scoped>
.navbar {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-img {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.logo-text {
  color: white;
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  letter-spacing: 1px;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 30px;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  padding: 8px 16px;
  border-radius: 5px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.nav-link.router-link-active {
  background-color: rgba(255, 255, 255, 0.2);
  font-weight: 600;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 5px;
  transition: transform 0.3s ease;
}

.hamburger:hover {
  transform: scale(1.1);
}

.bar {
  width: 25px;
  height: 3px;
  background-color: white;
  margin: 3px 0;
  transition: 0.3s;
  border-radius: 2px;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .hamburger {
    display: flex;
  }
  
  .nav-menu {
    position: fixed;
    left: -100%;
    top: 70px;
    flex-direction: column;
    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
    width: 100%;
    text-align: center;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.1);
    padding: 20px 0;
    gap: 0;
    opacity: 0;
    transform: translateX(-20px);
  }
  
  .nav-menu.active {
    left: 0;
    opacity: 1;
    transform: translateX(0);
  }
  
  .nav-link {
    margin: 10px 0;
    padding: 15px 20px;
    width: 100%;
    display: block;
  }
  
  .nav-container {
    padding: 0 15px;
  }
  
  .logo-text {
    font-size: 1.5rem;
  }
  
  .logo-img {
    height: 35px;
  }
}

@media screen and (max-width: 600px) {
  .logo-text {
    display: none;
  }
  
  .logo-img {
    height: 32px;
  }
}

@media screen and (max-width: 480px) {
  .nav-container {
    height: 60px;
  }
  
  .nav-menu {
    top: 60px;
  }
  
  .logo-text {
    display: none;
  }
  
  .logo-img {
    height: 30px;
  }
}
</style>
